import { useMemo, useState } from 'react';

import { ProgressMultiItem } from 'twyne-new.ui';

import Form from './Form';

export default function Item({ data, options, index, total, onChange, onRemove }) {
  const [toggle, setToggle] = useState(false)

  const name = useMemo(() => options?.find(offer => offer.value === data.id)?.label, [options, data])
  const { weight } = data
  const target = `offer-${index}`

  return <>
    <ProgressMultiItem
      value={(weight / total) * 100}
      label={name}
      onClick={() => setToggle(!toggle)}
      className='cursor-pointer'
    />
    <Form
      target={target}
      index={index}
      data={data}
      options={options}
      name={name}
      onChange={onChange}
      onRemove={onRemove}
      toggle={toggle}
      setToggle={setToggle}
    />
  </>
}
